import React from 'react';
import { CATEGORIES, LEGEND_ORDER, catColor } from '../../config/categories';
import { fs } from '../../utils/typography';

// Legend footer shared by the Month/Week/List views: "CATEGORIES" mono label
// plus a dot + label for each of the five event categories.
const CalendarLegend = ({ tokens }) => {
    const c = tokens.colors;
    return (
        <div
            className="hidden md:flex"
            style={{
                alignItems: 'center', flexWrap: 'wrap', gap: 16, padding: '7px 26px',
                flex: '0 0 auto', background: c.surfaceAlt, borderTop: `1px solid ${c.gridLine}`,
            }}
        >
            <span style={{
                fontFamily: tokens.fonts.mono, fontSize: fs(11), letterSpacing: 0.6,
                textTransform: 'uppercase', color: c.faint, fontWeight: 600,
            }}>Categories</span>
            {LEGEND_ORDER.map((cat) => {
                const cc = catColor(cat, tokens);
                return (
                    <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <i className={`fas ${CATEGORIES[cat].icon}`} style={{ color: cc.strong, fontSize: fs(12), width: 14, textAlign: 'center' }} aria-hidden="true" />
                        <span style={{ fontFamily: tokens.fonts.ui, fontSize: fs(13), color: c.muted, fontWeight: 500 }}>
                            {CATEGORIES[cat].label}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default CalendarLegend;
